export default __webpack_public_path__ + "static/media/logo7.5a5091bd.png";